import { faRefresh } from '@fortawesome/free-solid-svg-icons';

import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { AuthService, NotificationService } from '@core/services';

import { ResetData } from '@shared/types';

@Component({
    selector: 'app-resend-email',
    templateUrl: './resend-email.component.html',
    styleUrls: ['./resend-email.component.scss'],
    standalone: false,
})
export class ResendEmailComponent {
    public resetForm = new FormGroup({
        email: new FormControl('', [Validators.required, Validators.email]),
    });
    busy = false;
    success = false;
    public loadingIcon = faRefresh;

    constructor(private authService: AuthService, private notificationService: NotificationService) {}

    onSubmit() {
        this.busy = true;
        let data = this.resetForm.value as ResetData;
        this.authService.resendVerificationEmail(data.email).subscribe({
            next: () => {
                this.busy = false;
                this.success = true;
            },
            error: (err: Error) => {
                console.error('Something went wrong while requesting new verification email:', err);
                this.notificationService.errorMessage(
                    $localize`:@@resendEmail.error.requestFailed:Er ging iets fout tijdens het opnieuw aanvragen van een verificatiemail. Probeer later opnieuw.`,
                );
                this.busy = false;
            },
        });
    }
}
